/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_PostsInputs */

const he_nav_posts = /** @type {(inputs: Nav_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`פוסטים`)
};

const en_nav_posts = /** @type {(inputs: Nav_PostsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posts`)
};

/**
* | output |
* | --- |
* | "Posts" |
*
* @param {Nav_PostsInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_posts = /** @type {((inputs?: Nav_PostsInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_PostsInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_nav_posts(inputs)
	return en_nav_posts(inputs)
});